// extracted by mini-css-extract-plugin
export var buttons = "_bj-0";
export var buttonsActive = "_bj-h";
export var cancelConfirm = "_bj-1";
export var closeButton = "_bj-2";
export var column = "_bj-3";
export var container = "_bj-4";
export var detailHeader = "_bj-6";
export var detailTitle = "_bj-7";
export var detailsContent = "_bj-5";
export var header = "_bj-8";
export var headerWithClose = "_bj-9";
export var icon = "_bj-a";
export var infoIcon = "_bj-c";
export var informationContainer = "_bj-b";
export var sideDrawer = "_bj-d";
export var sideDrawerOpen = "_bj-e";
export var stickyFooter = "_bj-f";
export var typeOption = "_bj-g";